
import { HostListener, Injectable, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, of, Subject, Subscription, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { applicationConstants, encodeConst } from '../constants';
import { LocationStrategy } from '@angular/common';
import { map } from 'rxjs/internal/operators/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as CONSTANTS from '../constants';
import * as CryptoJS from 'crypto-js';
import { ECIF_SINGLE_SUCCESS_RESPONSE } from '../dummy_data/dummy_ecif_single_success_response';
import { ECIF_SINGLE_SUGGESTION_RESPONSE } from '../dummy_data/dummy_ecif_single_suggesstion_reaponse';
import { ECIF_DOUBLE_SUCCESS_RESPONSE } from '../dummy_data/dummy_ecif_double_success_response';
import { ECIF_DOUBLE_SUGGESTION_RESPONSE } from '../dummy_data/dummy_ecif_double_suggesstion_reaponse';
import { TRANS_UNION_FAILURE } from '../dummy_data/dummy_TU_failure_response';
import { TRANS_UNION_SUCCESS } from '../dummy_data/dummy_TU_success_response';
import { MHttpClient } from '@mmortgage/common-utility';
import { I18nService } from './i18n.service';
import { Error, maModel } from '../model/pre-qual-data.model';


@Injectable({
  providedIn: 'root'
})
export class UtilService implements OnDestroy {
  public windowWidth = new BehaviorSubject<number>(window.innerWidth);
  public progressPercent = new BehaviorSubject<number>(0);
  public sidebarTitle = new BehaviorSubject<string>('');
  public isSidebarVisible = new BehaviorSubject<boolean>(true);
  public isSummaryPage = new BehaviorSubject<boolean>(false);
  public SIDE_BAR_EVENT = new BehaviorSubject<string>('');
  public LOADER = new BehaviorSubject<boolean>(false);
  public CLOSE_WINDOW_POPUP = new BehaviorSubject<boolean>(false);
  public enumData: any;
  public isCoApplicantFlowStarted: boolean = false;
  public summaryAnd: string;
  public is_coapplicant_applied = new BehaviorSubject<string>('');
  public IS_MA_ASSIGNED: BehaviorSubject<{ maModelObj: maModel, setObj: boolean }> =
    new BehaviorSubject<{ maModelObj: maModel, setObj: boolean }>({ maModelObj: new maModel(), setObj: false });

  preQualObj: any;
  currentLang: any;
  prequalType = 'P';
  switchType = 'S';
  un_sub_closeWindowPopup: Subscription;
  currentPageName: string = '';


  constructor(private _activatedRoute: ActivatedRoute,
    private location: LocationStrategy, private http: HttpClient, private mhttp: MHttpClient,
    private translate: TranslateService, private i18nService: I18nService,
  ) {
    this.un_sub_closeWindowPopup =
      this.CLOSE_WINDOW_POPUP.subscribe(obj => {
        this.showOrHideWindowPopup(obj);
      });

  }
  ngOnDestroy(): void {
    if (this.un_sub_closeWindowPopup) {
      this.un_sub_closeWindowPopup.unsubscribe();
    }
  }

  evaluateDisplay(width, isfirstSectionFormValid: boolean, clickedOnToProceed: boolean) {
    //This logic is used when the user changes the window size .
    //This logic evaluates if the first section form is valid and proceed btn is click(only on smaller device) than display second section
    //If the user changes the window size from small to big , display both sections.
    let displaySectionDetails = {
      displayFirstSection: applicationConstants.yes,
      displaySecondSection: applicationConstants.yes
    }
    if (width > applicationConstants.mediumDeviceWidth) {
    } else if (width < applicationConstants.mediumDeviceWidth) {
      if (isfirstSectionFormValid && clickedOnToProceed) {
        displaySectionDetails.displayFirstSection = applicationConstants.no;
      } else {
        displaySectionDetails.displaySecondSection = applicationConstants.no;
      }
    }
    return displaySectionDetails;
  }

  getFormattedAddress(place) {
    return {
      'addLine1': this.getStreetNumber(place) + this.getStreet(place),
      'city': this.getCity(place),
      'province': this.getState(place),
      'postalCode': this.getPostCode(place)
    }
  }
  getAddrComponent(place, componentTemplate) {
    let result;

    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (componentTemplate[addressType]) {
        result = place.address_components[i][componentTemplate[addressType]];
        return result;
      }
    }
    return;
  }

  getStreetNumber(place) {
    const COMPONENT_TEMPLATE = { street_number: 'short_name' },
      streetNumber = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return streetNumber ? streetNumber + ',' : '';
  }
  getStreet(place) {
    const COMPONENT_TEMPLATE = { route: 'long_name' },
      street = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return this.nullCheck(street);
  }
  getPostCode(place) {
    const COMPONENT_TEMPLATE = { postal_code: 'long_name' },
      postCode = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return this.nullCheck(postCode);
  }


  getCity(place) {
    const COMPONENT_TEMPLATE = { locality: 'long_name' },
      city = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return this.nullCheck(city);
  }
  //Postal Code
  getState(place) {
    const COMPONENT_TEMPLATE = { administrative_area_level_1: 'short_name' },
      state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return this.nullCheck(state);
  }
  nullCheck(valueToEvaluate) {
    if (valueToEvaluate) {
      return valueToEvaluate;
    } else {
      return '';
    }
  }

  saveError(reqestPreQual, error): Observable<any> {

    this.translate.get('requestcallpage.errTitle').subscribe((res: string) => {
      reqestPreQual.failure_reason = res || "";

    });

    reqestPreQual.failure_code = 101;
    if (environment.isencryptionenabled === encodeConst.yes) {
      const reqBody = { encodedRequestPreQual: this.encode(JSON.stringify(reqestPreQual)) };
      return this.post(environment.backend_base_url + "advisorService/save", reqBody).
        pipe(map((response: any) => this.decodeText(response.encryptedResponse)))
    }
    else {
      return this.post(environment.backend_base_url + "advisorService/save", reqestPreQual)
    }
  }
  saveJson(reqestPreQual): Observable<any> {
    let url = "advisorService/save";
    if (this.currentPageName == "cibc-customer-selection") {
      url = "integrationservice/save";
    }
   return this.encryptionDecryption(url, reqestPreQual);
  }
  encryptionDecryption(url,requestPayload) {
    if (environment.isencryptionenabled === encodeConst.yes) {
      const reqBody = { encodedRequestPreQual: this.encode(JSON.stringify(requestPayload)) };
      return this.post(environment.backend_base_url + url, reqBody).pipe(map((response: any) => {
        return JSON.parse(this.decodeText(response.encryptedResponse));
      }
        ));
    }
    else {
      return this.post(environment.backend_base_url + url, requestPayload)
    }
  }
  decryptionGet(url) {
    if (environment.isencryptionenabled === encodeConst.yes) {
      return this.get(environment.backend_base_url + url).pipe(map((response: any) => {
        return JSON.parse(this.decodeText(response.encryptedResponse));
      }
       ));
    }
    else {
      return this.get(environment.backend_base_url + url);
    }
  }
  getRateOffers() {
    return this.decryptionGet("integrationservice/getEPCPdts");
  }
  getSwitchDetails(reqBody, indicator) {
    const url = `integrationservice/submitSwitch/${indicator}`;
    return this.encryptionDecryption(url, reqBody);
  }



  getJson(applicationID) {
      return this.decryptionGet("advisorService/getApplication/" + applicationID);
  }

  postMA(applicationID, reqBody) {
    if (environment.isencryptionenabled === encodeConst.yes) {
      if (environment.simulators == "true") {
        return this.post(environment.backend_base_url + "integrationservice/cbpullTest/" +
          atob(sessionStorage.getItem("transactionid")), reqBody).pipe(map((response: any) =>
            this.decodeText(response.encryptedResponse)))
      } else {
        return this.post(environment.backend_base_url + "integrationservice/cbpull/" + atob(sessionStorage.getItem("transactionid")), reqBody).
          pipe(map((response: any) => this.decodeText(response.encryptedResponse)))
      }
    }
    else {
      if (environment.simulators == "true") {
        return this.post(environment.backend_base_url + "integrationservice/cbpullTest/" + atob(sessionStorage.getItem("transactionid")), reqBody)
      } else {
        return this.post(environment.backend_base_url + "integrationservice/cbpull/" + atob(sessionStorage.getItem("transactionid")), reqBody)
      }
    }
  }

  demoGetEcifResponse(requestBody) {
    return this.encryptionDecryption(`integrationservice/addressValidate/${requestBody.request_id}`, requestBody)
  }

  demoTransUnionSuccessResponse(reqBody, request_id, prequalData) {
    if (prequalData.flow_type == this.prequalType) {
       return this.encryptionDecryption(`integrationservice/idCbgVerify/prequal/${request_id}`, reqBody);

    }
    else if (prequalData.flow_type == this.switchType) {
       return this.encryptionDecryption(`integrationservice/idCbgVerify/switch/${request_id}`, reqBody);
    }
  }
  demoTransUnionFailureResponse(reqBody) {
    return of(JSON.parse(JSON.stringify(TRANS_UNION_FAILURE)));
  }
  demoTransUnionResponse(reqBody, userIndex, request_id, prequalData) {
    if (userIndex == 0) {
      return this.demoTransUnionSuccessResponse(reqBody, request_id, prequalData);
    } else {
      return this.demoTransUnionSuccessResponse(reqBody, request_id, prequalData);
    }
  }
  getLiabilities(reqBody) {
    return this.encryptionDecryption("integrationservice/getLiabilities", reqBody);
  }

  getfromSession(key) {
    return JSON.parse(atob(sessionStorage.getItem(key)));
  }
  storeInSession(key, val) {
    sessionStorage.setItem(key, btoa(JSON.stringify(val)));
  }
  setEnumData(enumObj) {
    this.enumData = enumObj;
  }
  getEnumData() {
    return this.enumData;
  }
  isPrimaryApplicantAlreadyAdded() {
    let sessionData = this.getSessionStorage();
    if (sessionData && sessionData.users && sessionData.users.length == 1) {
      return true;
    }
    return false;
  }
  setSessionStorage(data) {
    sessionStorage.setItem('pre_qual_data', btoa(this.toBinary(JSON.stringify(data))));
  }
  getSessionStorage() {
    let sessionData = sessionStorage.getItem('pre_qual_data');

    if (sessionData && sessionData !== "undefined") {
      let obj1 = this.fromBinary(atob(sessionData))
      let obj = JSON.parse(obj1)
      return obj;
    }
    return sessionData;
  }
  determineNextRoute(currentRoutePath) {
    let nextRoutePath = '';
    switch (currentRoutePath) {
      case 'home':
        nextRoutePath = 'co-applicant-selection';
        break;
      case 'co-applicant-selection':
        nextRoutePath = 'cibc-customer-selection';
        break;

      case 'second-applicant-flow':
        nextRoutePath = 'cibc-customer-selection';
        break;

      case 'co-applicant-selection':
        nextRoutePath = 'cibc-customer-selection';
        break;
      case 'cibc-customer-selection':
        let sessionData = this.getSessionStorage();
        if (sessionData.is_primary_applicant_CIBC_customer == false || sessionData.is_primary_applicant_CIBC_customer == 'NO') {
          nextRoutePath = 'personal-information-about-yourself';
        }
        else if (sessionData.is_primary_applicant_CIBC_customer == true || sessionData.is_primary_applicant_CIBC_customer == 'YES') {
          nextRoutePath = 'personal-information';

        }
        else {
          nextRoutePath = 'request-callback';
        }
        break;

      case 'personal-information-about-yourself':
        nextRoutePath = 'personal-information-address';

        break;

      case 'personal-information-preview':

        nextRoutePath = 'income'
        break;

      case 'verify-identity':
        // nextRoutePath = 'cb-consent';
        if (this.isCoApplicantPresent()) {
          nextRoutePath = this.isPrimaryApplicantAlreadyAdded() ? 'co-applicant-flow-start' : 'time-to-purchase';

        }
        else {
          nextRoutePath = 'time-to-purchase';
        }

        break;
      case 'personal-information-contact':
        nextRoutePath = 'personal-information-preview';


        break;
      case 'personal-information':
        nextRoutePath = 'income';
        break;
      case 'cb-consent':
        let sessionDoc = this.getSessionStorage();

        let objUser = sessionDoc.users[sessionDoc.users.length - 1];;


        if (objUser.is_existing_bankcustomer == "Y" || objUser.is_existing_bankcustomer == true) {
          if (sessionDoc.is_coapplicant_applied == "N") {
            nextRoutePath = 'time-to-purchase';
          }
          else {
            nextRoutePath = this.isPrimaryApplicantAlreadyAdded() ? 'co-applicant-flow-start' : 'time-to-purchase';

          }


        }
        else {
          nextRoutePath = 'verify-identity';


        }

        break;
      case 'co-applicant-flow-start':
        nextRoutePath = 'cibc-customer-selection';
        break;
      case 'time-to-purchase':
        nextRoutePath = 'cb-consent';
        break;
      case 'income':
        nextRoutePath = 'time-to-purchase';
        break;
      default:
        nextRoutePath = 'request-callback';
        break;
    }
    return '../' + nextRoutePath;
  }
  isCoApplicantFlowApplicable() {
    let sessionData = this.getSessionStorage();

    if (sessionData.is_coapplicant_applied == "Y" && this.isPrimaryApplicantAlreadyAdded()) {
      return true;
    }
    return false;
  }

  isCoApplicantPresent() {
    let sessionData = this.getSessionStorage();

    if (sessionData.is_coapplicant_applied == "Y" || sessionData.is_coapplicant_applied == true) {
      return true;
    }
    return false;
  }
  getDMRespone(requestBody) {
    return this.encryptionDecryption("integrationservice/submitPrequal", requestBody);
  }


  backButtonDisable() {
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }

  getApplicantNames() {
    this.currentLang = this.i18nService.getCurrentLang();
    this.preQualObj = this.getSessionStorage();
    if (this.preQualObj.users.length == 2) {

      this.translate.get('summarypage.and').subscribe((res: string) => {
        this.summaryAnd = res || "";
      });
      if (this.currentLang == "en") this.summaryAnd = "&"
      else if (this.currentLang == "fr") this.summaryAnd = "et";
      return this.preQualObj.users[this.preQualObj.users.length - 2].firstname
        + " " + this.summaryAnd + " " + this.preQualObj.users[this.preQualObj.users.length - 1].firstname;
    } else {
      return this.preQualObj.users[this.preQualObj.users.length - 1].firstname;
    }
  }


  loadData() {

    return this.get_prequal('assets/Json/enum_data.json');
  }
  loadSampleData() {
    return this.get_prequal('assets/Json/sample_data.json');
  }
  getquestionandAnsChoice(reqBody) {

    return this.get(environment.backend_base_url + environment.api.getquestionandAnsChoice
      + atob(sessionStorage.getItem("transactionid")));

  }


  getUTCDateTime() {
    const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
      'Oct', 'Nov', 'Dec'],
      today = new Date(),
      utcDt = today.toUTCString().split(/[\s,]+/), // ["Wed", "30", "Jun", "2021", "10:27:57", "GMT"]
      month = monthArr.indexOf(utcDt[2]) + 1,
      date = parseInt(utcDt[1]),
      monthDisplayFormat = month < 10 ? '0' + month : month, // Show month number as '05'
      dateDisplayFormat = date < 10 ? '0' + date : date,
      formattedDt = utcDt[3] + '-' + monthDisplayFormat + '-' + dateDisplayFormat + ' ' + utcDt[4];
    return formattedDt;
  }
  setCoApplicantFlow(flag) {
    this.isCoApplicantFlowStarted = flag;
    sessionStorage.setItem('co-applicant-flow', "yes")
  }

  assessmentScore(reqObj) {
    return this.post(environment.backend_base_url + environment.api.assessmentScore + "/" + atob(sessionStorage.getItem("transactionid")), reqObj);
    // +"/"+atob(sessionStorage.getItem("transactionid"))
  }
  getToken() {
    let time = Math.floor((new Date()).getTime() / 1000)
    const reqBody = { encodedKey: this.encode(JSON.stringify({ "username": environment.api.loginIDAuth, "password": environment.api.loginPwAuth, "timestamp": time })) };
    return this.post_Prequal(environment.backend_base_url + "advisorService/authenticate", reqBody);
  }

  getAuditHistory(applicationId) {
    return this.get_prequal(environment.backend_base_url + "advisorservice/getAuditHistory/" + applicationId);
  }

  getAuditResponse(applicationId, auditId) {
    return this.get_prequal(environment.backend_base_url + "advisorservice/getAuditResponse/" + applicationId + "/" + auditId);
  }

  getAuditRequest(applicationId, auditId) {
    return this.get_prequal(environment.backend_base_url + "advisorservice/getAuditRequest/" + applicationId + "/" + auditId);
  }

  count: number = 0
  getCount() {
    return this.count
  }

  setCount(count) {
    this.count = count
  }

  toBinary(string) {
    const codeUnits = new Uint16Array(string.length);
    for (let i = 0; i < codeUnits.length; i++) {
      codeUnits[i] = string.charCodeAt(i);
    }
    const charCodes = new Uint8Array(codeUnits.buffer);
    let result = '';
    for (let i = 0; i < charCodes.byteLength; i++) {
      result += String.fromCharCode(charCodes[i]);
    }
    return result;
  }

  fromBinary(binary) {
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    const charCodes = new Uint16Array(bytes.buffer);
    let result = '';
    for (let i = 0; i < charCodes.length; i++) {
      result += String.fromCharCode(charCodes[i]);
    }
    return result;
  }


  //  ******** function moved from m-http-client.service.ts to stop circular dependecy error. *****

  post(apiUrl, body) {
    let headers = new HttpHeaders({
      'Authorization': "Bearer " + this.getfromSession("auth_token"),
    });
    // return this.http.post(apiUrl, body, { headers: headers }).pipe(map(response => this.decodeText(response)));
    return this.http.post(apiUrl, body, { headers: headers });

  }



  get(apiUrl) {
    let headers = new HttpHeaders({
      'Authorization': "Bearer " + this.getfromSession("auth_token")
    });
    return this.http.get(apiUrl, { headers: headers });
  }

  post_Prequal(apiUrl, body) {
    return this.http.post(apiUrl, body);
  }
  get_prequal(apiUrl) {
    return this.http.get(apiUrl);
  }
  /**
   * 
   * @param strObj  json object in string format 
   * @param key secreate key
   * @returns encoded value
   */
  encode(strObj) {
    // var CryptoJS = require("crypto-js");
    return CryptoJS.AES.encrypt(strObj, CONSTANTS.encodeConst.key).toString();

  }

  decodeText(encryptedCipherText) {
    var encryptedBase64Key = environment.api.encryptedKey;
    var parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);
    var decryptedData = CryptoJS.AES.decrypt(encryptedCipherText, parsedBase64Key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    var decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  }
  /**
   * 
   * @param obj encoded obj
   * @param key secreate key
   * @returns decoded value
   * 
   */
  decode(obj) {

  }
  getImportCustomerPortal(requestBody) {
    if (environment.isencryptionenabled === encodeConst.yes) {
      requestBody = { encodedRequestPreQual: this.encode(JSON.stringify(requestBody)) };
    }
      return this.post(environment.backend_base_url + "integrationservice/exportLead", requestBody);
    
  }
  //Added for showing the window PopUp
  showOrHideWindowPopup(show: boolean) {
    if (show) {
      window.addEventListener('beforeunload', this.beforeUnloadListener);
    }
    else {
      window.removeEventListener('beforeunload', this.beforeUnloadListener);

    }
  }
  beforeUnloadListener = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = 'Are you sure you want to leave? Unsaved changes may be lost.';
    return event.returnValue;
  };
  //end
  AdobeData(digitalData) {
    if (document.getElementById("adobe-tracking-digital-data")) {
      document.getElementById("adobe-tracking-digital-data").remove();
      let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData =" + digitalData + "; if(_satellite){ _satellite.track('track'); }</script>"
      $("head").append(element);
    }
  }
  adobeAnalyticalErrorMsg(field: string, type: string, code: string, errorObj: any = null) {
    let adobeErrObj = [{
      type: type,
      field: field,
      subtype: "",
      code: code
    }]
    if (errorObj != null) {
      adobeErrObj = errorObj;
    }
    const event = { error: true }
    let datajson = {
      "errors": adobeErrObj,
      "events": event
    }
    const digitalDataJson = JSON.stringify(datajson, null, 2)
    this.AdobeData(digitalDataJson);
  }
  getFlowType(params) {

    if (Object.keys(params).length !== 0) {
      const productFlow = params["flow"];
      if (!productFlow) {
        return { "type": "P" }
      }
      else if (productFlow === 'switch') {
        return { "type": "S" }
      }
    }
    else {
      return { "type": "P" }
    }
  }
  getReferral(params) {
    if (Object.keys(params).length !== 0) {
      const referralFlow = params["referralLink"];
      return referralFlow;
    }
  }
  validateCurrency(amount: any, maxlength: number) {
    const strAmount = amount.toString();
    if (strAmount.includes('.')) {
      const integerPart = strAmount.split('.')[0];
      return typeof amount === 'number' ? Number(integerPart.substring(0, maxlength)) : integerPart.substring(0, maxlength);
    }
    return typeof amount === 'number' ? Number(strAmount.substring(0, maxlength)) : strAmount.substring(0, maxlength)
  }
  setsessionStorageGeneric(key, data) {
    sessionStorage.setItem(key, btoa(this.toBinary(JSON.stringify(data))));
  }
  getSessionStorageGeneric(key) {
    let sessionData = sessionStorage.getItem(key);
    if (sessionData && sessionData !== "undefined") {
      let obj1 = this.fromBinary(atob(sessionData))
      let obj = JSON.parse(obj1)
      return obj;
    }
    return sessionData;
  }
  equityCheck() {
    let prequalData = this.getSessionStorage();
    console.log(prequalData, "prequalData");
    let equityRatio = (prequalData.property_estimated_value - prequalData.mortgage_balance) / prequalData.property_estimated_value;
    let equityPercentage = equityRatio * 100;

    prequalData['equity_ratio'] = equityPercentage.toString();
    prequalData['equity_amount'] = (prequalData.property_estimated_value - prequalData.mortgage_balance).toString();
    this.setSessionStorage(prequalData);
    if ((equityPercentage < 5 || (equityPercentage >= 5 && equityPercentage < 20 && prequalData.property_estimated_value >= 1500000))) {
      return true;
    }
    return false;
  }

}

//// ************  End  *********************

